import { useEffect } from 'react'
import { Select } from 'antd'
import useSWR from 'swr'
import { useTranslation } from 'react-i18next'
import { fetchDiskList } from '@/service/disk'
import PermissionTag from '@/app/components/mlops/PermissionTag'
import { useAppContext } from '@/context/app-context'

type DiskSelectProps = {
  value?: string
  onChange?: (value: string) => void
  disabled?: boolean
  className?: string
  writable?: boolean
  region_name?: string
}

const DiskSelect = ({
  value,
  onChange,
  disabled = false,
  className = '',
  writable = false,
  region_name = '',
}: DiskSelectProps) => {
  const { t } = useTranslation()
  const disk_id = value
  const { userProfile } = useAppContext()
  const {
    data: { data: disks },
    mutate,
  } = useSWR({ params: { region_name } }, fetchDiskList, {
    fallbackData: {
      data: [],
      page: 1,
      limit: 100,
      total: 0,
      has_more: false,
    },
  })

  useEffect(() => {
    if (
      !disabled &&
      disk_id &&
      disks.length &&
      !disks.find(disk => disk.id === disk_id)
    ) {
      onChange?.('')
    }
  }, [disks])

  return (
    <Select
      className={className}
      disabled={disabled}
      placeholder={t('mlops.label.selectDisk')}
      value={disk_id}
      onChange={onChange}>
      {disks
        .filter(disk => {
          if (writable) 
            return disk.created_by === userProfile.id
          return true
        })
        .map(disk => (
          <Select.Option key={disk.id} value={disk.id}>
            <PermissionTag value={disk.permission} />
            {/* <Tag color='blue'>{disk.storage_cluster.region_name}</Tag> */}
            {disk.alias || disk.name}
          </Select.Option>
        ))}
    </Select>
  )
}

export default DiskSelect
